__turbopack_context__.v({
  "root": "Footer-module__cj9z3W__root",
});
